import { useRouter } from "next/router"
import Layout from "components/layout"
import Seo from "components/seo"
import {
  F_Q_LIST_GALLERY,
  F_Q_GALLERY,
  F_Q_GALLERY_CATEGORIES,
} from "lib/function"
import Helmet from "react-helmet"
import ProjectGalleryDetailHeader from "@components/pages/project-gallery/project-gallery-detail-header"
import ProjectGalleryDetailProducts from "@components/pages/project-gallery/project-gallery-detail-products"
import ProjectGalleryDetailSlider from "@components/pages/project-gallery/project-gallery-detail-slider"

export default function ProjectGalleryDetail({ data }) {
  const router = useRouter()

  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  if (router.isFallback) {
    return <div>Loading...</div>
  }
  return (
    <>
      <Seo description={`${data?.title} | ${data?.description}`} />
      <Helmet>
        <body className="bd-project-gallery-detail" />
      </Helmet>
      <Layout>
        <ProjectGalleryDetailHeader data={data} />
        <ProjectGalleryDetailSlider list={data?.images} />
        <ProjectGalleryDetailProducts list={data?.related_products} />
      </Layout>
    </>
  )
}

export async function getStaticPaths() {
  const token = process.env.INIT_TOKEN

  // fetch all galleries
  const galleriesResponse = await F_Q_LIST_GALLERY({ language: "en" }, token)
  const galleries = galleriesResponse?.data?.galleries || []
  let paths = []

  // Create paths for each locale
  const locales = ["en", "id"]

  locales.forEach((locale) => {
    // For each gallery, create a path with both category and gallery slugs
    galleries.forEach((gallery) => {
      paths.push({
        params: {
          categoryslug: `${gallery?.category.slug}-${gallery?.category.id}`,
          slug: `${gallery.slug}-${gallery.id}`,
        },
        locale,
      })
    })
  })
  return {
    paths,
    fallback: true,
  }
}

export async function getStaticProps({ params, locale }) {
  const token = process.env.INIT_TOKEN
  const slugParts = params.slug.split("-")
  const galleryId = slugParts[slugParts.length - 1]
  try {
    // Fetch the gallery detail data
    const response = await F_Q_GALLERY(
      {
        id: galleryId,
        language: locale,
      },
      token
    )
    // If no data was found, return notFound
    if (!response?.data?.gallery) {
      return {
        notFound: true,
        revalidate: 60, // Revalidate every 60 seconds
      }
    }

    return {
      props: {
        data: response?.data?.gallery || null,
      },
      revalidate: 60, // Revalidate every 60 seconds
    }
  } catch (error) {
    return {
      notFound: true,
      revalidate: 60, // Revalidate every 60 seconds
    }
  }
}
